var _circle, _circle2, _circle3, _polyline, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlgovexWordmarkDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 27,
    stroke: "#1e2a2a",
    strokeWidth: 1,
    fill: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 27,
    stroke: "#00d4aa",
    strokeWidth: 1.5,
    fill: "none",
    strokeDasharray: "42 128",
    strokeDashoffset: -18,
    opacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 27,
    stroke: "#00d4aa",
    strokeWidth: 1.5,
    fill: "none",
    strokeDasharray: "21 149",
    strokeDashoffset: -75,
    opacity: 0.35
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "13,36 21,36 25,24 31,47 36,29 41,41 45,32 51,32 56,36 59,36",
    stroke: "#00d4aa",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 3,
    fill: "transparent"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 3,
    stroke: "#00d4aa",
    strokeWidth: 1.5,
    fill: "none"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 1.2,
    fill: "#00d4aa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgovexWordmarkDark);
export default __webpack_public_path__ + "static/media/algovex-wordmark-dark.dce2ee281c57599d39bacb7f57fe5466.svg";
export { ForwardRef as ReactComponent };